
import WDElement from '../wd-element';
import WDButton from '../button/wd-button';
import WDNavbar from '../navbar/wd-navbar';

export default class WDCard extends WDElement {

  #body = null;
  #header = null;
  #footer = null;
  #config = null;
    
  constructor(cfg) {

    super().classList.add('wd-card');
    this.#config = cfg ? Object.assign({},cfg) : {};

    return this;
  };

  get config() { return this.#config; };

  get body()
  {
    if (!this.#body)
    {
      this.#body = new WDCardBody();
      this.append(this.#body);
    }
    
    return this.#body;
  };

	get header()
  {
    if (!this.#header) 
    {
      this.#header = new WDCardHeader();
      this.body.before(this.#header);
    }
    return this.#header;
  };

	get footer()
  {
    if (!this.#footer) 
    {
      this.#footer = new WDCardFooter();
      this.body.after(this.#footer);
    }
    return this.#footer;
  };

	//convenience methods
	get navbar() { return this.header.navbar; };
	get toolbar() { return this.footer.navbar; };
	get title() { return this.header.title; };

	cleanupCallback()
	{
		// Clean up child components
		if (this.#header) {
			this.#header = null;
		}

		if (this.#body) {
			this.#body = null;
		}

		if (this.#footer) {
			this.#footer = null;
		}

		// Clear config
		this.#config = null;

		super.cleanupCallback();
	}
	
};export class WDCardHeader extends WDElement {

  #title = null;
  #buttons = null;
  #navbar = null;
  #toggleButton = null;
  #icon = null;
  #config = {};
  
  constructor(cfg)
  {
    super(cfg).classList.add('wd-card-header');

    Object.assign(this.#config,cfg);

    if (cfg?.icon) this.icon = cfg.icon;
    if (cfg?.title) this.title = cfg.title;

    return this;
  };

  get toggleButton()
  {
    if (!this.#toggleButton)
    {
      this.#toggleButton = new WDButton({fasIcon:'chevron-right', click:(evt) => this.closest('.wd-card').toggle(evt) });
      this.prepend( this.#toggleButton );
    }
    
    return this.#toggleButton;
  };

  set icon(str)
  {
    if (!this.#icon)
    {
			this.#icon = wdc('<div class="wd-card-header-icon"/>');
			this.prepend(this.#icon);
    }
  
    const iconClasses = Array.isArray(str) ? str : str.split(' ');
    iconClasses.push('wd-card-header-icon');
      
    this.#icon.setAttribute('class','');
    this.#icon.classList.add(...iconClasses);  
  };  

  get title() { return this.#title.innerText; };
  set title(val)
  {
		if (!this.#title)
		{
      this.#title = wdc('<div class="wd-card-header-title"/>');
			this.prepend(this.#title);
		}
		
		this.#title.replaceChildren(val);
  };

  get navbar()
  {
		if (!this.#navbar)
		{
			this.#navbar = new WDNavbar();
			this.append(this.#navbar);
			this.classList.add('has-navbar');
		}
			
		return this.#navbar;
	};

	get buttons()
	{
		if (!this.#buttons)
		{
			 this.#buttons = wdc('<div class="wd-card-header-buttons"/>');
			 this.append(this.#buttons);
		}
			
		return this.#buttons; 
	};

	addButton(cfg)
	{
	  if (cfg && !cfg?.size) cfg.size = 'sm';

	  const btn = new WDButton(cfg);
		this.buttons.append(btn);
		return btn;
	};

};

export class WDCardFooter extends WDElement {

  #title = null;
  #buttons = null;
  #navbar = null;

  constructor()
  {
    super().classList.add('wd-card-footer');
    return this;
  };

  get buttons()
  {
		if (!this.#buttons)
		{
			 this.#buttons = wdc('<div class="wd-card-footer-buttons"/>');
			 this.prepend(this.#buttons);
		}
			
		return this.#buttons; 
	};

	addButton(cfg)
	{
	  if (cfg && !cfg?.size) cfg.size = 'sm';

	  const btn = new WDButton(cfg);
    this.buttons.append(btn);
    return btn;
  };

  addSpacer()
  {
    const spacer = wdc('<div class="wd-card-footer-spacer"/>');
    this.buttons.append(spacer);
  };
  
  get navbar()
  {
		if (!this.#navbar)
		{
			this.#navbar = new WDNavbar();
			this.append(this.#navbar);
			this.classList.add('has-navbar');
		}
			
		return this.#navbar;
	};

};

class WDCardBody extends WDElement {

  constructor()
  {
    super().classList.add('wd-card-body');
    return this;
  };
		
};

customElements.define('wd-card',WDCard);
customElements.define('wd-card-header',WDCardHeader);
customElements.define('wd-card-footer',WDCardFooter);
customElements.define('wd-card-body',WDCardBody);
